import React, { useMemo, useState } from 'react';
import "../RequestCards.css";
import img1 from "../../../assets/Hotels/cabRequest.png";
import button from "../../../assets/icons/ShadowButton.svg";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { baseUrl } from '../../../common/baseUrl';
import { isReviewable } from "../../../common/reviewStatus";

// In this CSS is same as in RequestCardCSS will Apply In this 

export default function PostTaxiCard(props) {

  const navigate  = useNavigate();

  const formattedStatus = useMemo(() => {
    if(props.status==="Declined_Guest"){
      return "Cancelled Guest"
    }
    return props.status.replace('_', ' ');
  }, [props.status]);

  // Format Checkin and CheckOut Date
  const formatDate = (dateString) => {
      // Create a new Date object from the date string
      const date = new Date(dateString);
  
      // Array of month names
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
      "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
  
      // Get the month and day from the Date object
      const month = monthNames[date.getMonth()]; // getMonth() returns the month index (0-11)
      const day = date.getDate(); // getDate() returns the day of the month (1-31)
  
      // Return the formatted string
      return `${month} '${day}`;
  };


  //  This is for Arrow 
  const handleClick = () => {
      navigate(`/requests/${props.requestId}`);
  };

  const editReviewModal = ()=>{
      try{
          props.setIsReviewModal(!props.isReviewModal)

          console.log("Booking ID : ",props.bookingId);
          console.log("Booked Room ID : ",props.bookedRoomId);
          console.log("Guest Request ID : ",props.guestRequestId);

          props.setRequestData({
              bookingId: props.bookingId,
              bookedRoomId: props.bookedRoomId,
              guestRequestId: props.guestRequestId,
              ratingRemarks : props?.rating_remark || "",
              rating : props?.rating || 0,
              view : "view"
          })

      }catch(error){
      console.log(error);
      }
  }


    

  return (
    <>
            <div className='request-card'  onClick={handleClick}>
      <div className='request-card-date'>
        <p>PostCheckIn Cab Request</p>
      </div>
      <div className='request-card-main'>
        <div className='request-card-side1'>
          <div className='request-card-header'>
            <h4>Cab</h4>
          </div>
          <div className='request-card-para'>
            <p style={{ fontSize: '13px', marginTop: '4px' }}>
              {props.hotelName}
            </p>
            <p style={{ fontSize: '11px', marginTop: '4px' }}>
              {formatDate(props.checkInDate)}- {formatDate(props.checkOutDate)}
            </p>
            <p style={{ color: "#ACB8C2", fontSize: '11px', marginTop: '4px' }}>
              {props.hotelAddress}
      
            </p>


              <div className='request-card-checkin'>
                <div className="request-card-badge">
                  <span>
                    {formattedStatus}
                  </span>
                </div>
                {(isReviewable(props.status) && props.is_rating_given) &&   <span className='rate-us' onClick={(e)=>{e.stopPropagation();editReviewModal();}}>view rating</span>}

              </div>


          </div>

          <div className='request-card-button'>
            <img src={button} alt="Redirect button" />
          </div>

        </div>

        <div className='request-card-side2'>
          <div className='request-card-img'>
            <img src={img1} alt="" />
          </div>
        </div>
      </div>
      </div>
    </>
  )
}
